export const MainContainerId = "kahun-patient";
export const MainContainerDesktopId = "app";
export const SettingsContainerId = "kahun-settings";
export const DialogueContainerId = "kahun-dialogue";
